import {
    Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box,
    Button, Divider, FormControl, FormControlLabel, Grid, InputLabel,
    MenuItem, Paper, Radio, RadioGroup, Select, TextField, Typography,
    InputAdornment, IconButton, Tooltip, Avatar, Modal, Stack
} from '@mui/material'
import { Component } from 'react';
import { withTranslation } from 'react-i18next'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../Styles/Colors';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import MaleIcon from '@mui/icons-material/Male';
import FemaleIcon from '@mui/icons-material/Female';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DateTime } from "luxon";
// import MUIRichTextEditor from "mui-rte";
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import { AmountFormat, formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import Loader from '../../../../Components/Loader';
import { CommonPatientDetails, DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import { getCachevalue, localGetItem, setCachevalue } from '../../../../Utility/Services/CacheProviderService';
// import ReservationList from './ReservationList';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PaymentsIcon from '@mui/icons-material/Payments';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import { CurrencySymbol } from '../../../../Utility/Constants';
import { DataGrid } from '@mui/x-data-grid';

export const IP_ADMISSION_CACHE_KEY = 'ip_admission_details_cache';

class IPAddmissionDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            IsMedicoLegal: false,
            PatientWardList: [],
            PatientBlockList: [],
            PatientFloorList: [],
            PatientBedList: [],
            PatientRoomList: [],
            PatientWard: "",
            PatientBlock: "",
            PatientFloor: "",
            PatientRoom: "",
            PatientBed: "",
            PatientFloorId: "",
            PatientBederror: false,
            PatientBedtext: "",

            AddmissionDateTime: new Date(),
            setMaxAdmissionDateTime: new Date(),
            DocList: [],
            Doctor: "",
            CoConsultant: "",
            NurseList: [],
            Nurse: "",
            TagList: [],
            Tag: "",
            VisitConsult1: "",
            VisitConsult2: "",
            VisitConsult3: "",
            VisitConsult4: "",
            Complaints: this.props.history?.location?.state?.SelectedPatientDetails?.complaints ? this.props.history?.location?.state?.SelectedPatientDetails?.complaints : "",
            MedicoDate: null,
            MedicoInformer: "",
            MedicoLocation: "",
            MedicoPoliceStation: "",
            MedicoComments: "",
            AttenderName: "",
            AttenderMobileNo: "",
            AttenderRelation: "",
            AttenderLocation: "",
            ConsentForAdmissionText: '',
            RestraintConsentText: '',
            PatientRoomType: "hourly",
            PatientDetails: this.props.PatientDetails,

            WardList: [],
            BackBtnClicked: false,
            DateOpen: false,
            PatientBedObj: {},
            ComplaintsList: localGetItem("ipComplaintsDataList") === null ? [] : JSON.parse(localGetItem("ipComplaintsDataList")),
            CreditLmt: 0,
            PharmaCreditLmt: 0,
            ReservationListPopup: null,
            PatientReservedData: {},
            SelectedDoctor: [],
            attrnder_Data: {},
            patient_Data: {},
            bed_ID: null,
            LastVisitObject: {},

            selectedPaymentType: JSON.parse(localGetItem('allow_patient_credit_bills')) ? 'Patient credit' : '',
            CorporateList: [],
            InsuranceList: [],
            selectedCorporate: null,
            selectedInsurance: null,
            selectedInsuranceNumber: '',
            selectedInsuranceCCNNumber: '',
            selectedCorporateNumber: '',
            selectedCorporateId: null,
            policyStatus: false,
            clinic_id: JSON.parse(localGetItem('SelectedDoctorClinicId')),
            isReservedPatient: false,
            reservationDetails: [],
            reservationDataPopup: false,
            reservationRoomDetails: null,
            selectedTPAName: null,
            TPAList: [],
            isTPAConfig: (localGetItem('tpa_insurance_config')) ? JSON.parse(localGetItem('tpa_insurance_config')) : false,
            is_dip_available: JSON.parse(localGetItem("loggedInUserInfo"))?.is_ip_dip_available || false, // django key
            is_ip_dip_available: false,
            is_user: false
        }
    }
    componentDidMount() {
        const fromBooking = this.props.history?.location?.state?.fromRoomBookingWithReservation;
        if (fromBooking) {
            const cached = getCachevalue(IP_ADMISSION_CACHE_KEY);
            if (cached) {
                try {
                    const { admissionState } = JSON.parse(cached);
                    if (admissionState) {
                        const roomKeys = ['PatientWard', 'PatientBlock', 'PatientFloor', 'PatientRoom', 'PatientBed', 'PatientWardList', 'PatientBlockList', 'PatientFloorList', 'PatientRoomList', 'PatientBedList', 'PatientBedObj', 'isReservedPatient', 'reservation_id', 'WardList'];
                        const restored = { ...admissionState };
                        roomKeys.forEach((k) => delete restored[k]);
                        this.setState(restored);
                    }
                    setCachevalue("", 'IP_ADMISSION_CACHE_KEY');
                } catch (e) { console.warn("Restore admission cache failed", e); }
            }
            this.props.history.replace({ pathname: this.props.history.location.pathname, state: {} });
        }
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        let clinicID = null
        if (UserData?.is_doctor) {
            clinicID = JSON.parse(localGetItem('SelectedDoctorClinicId'))
        } else {
            clinicID = UserData?.clinic_id ? UserData?.clinic_id : null
        }
        if (this.props?.consultant_id) {
            this.setState({ Doctor: this.props?.consultant_id })
        }
        this.setState({ clinic_id: clinicID, is_user: UserData?.is_user ?? false })
        this.GetIntialDatas()
        this.getInsuranceList()
        this.GetCorporateList()
        this.getTPAlist()
        this.GetRoomListData(new Date())
        if (Object.keys(this.props.bacKfromBilling).length !== 0 || this.props.isfrom_Patientdetails || this.props.is_From_Ip_AdmissionDetails) {
            this.getAdmissionData()
            this.GetPolicyStatus()
        } else if (this.props.PatientDetails?.patient_id) {
            this.getPatientDetails(this.props.PatientDetails?.patient_id)
            this.getLastVisitDateOutstandingAmount()
        }
    }

    getReservationData = () => {
        try {
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
            RestAPIService.getAll(Serviceurls.FO_PATIENT_RESERVATION + "?ward_id=" + (typeof (this.state.PatientWard) === "number" ? this.state.PatientWard : '') + "&clinic_id=" + (UserData?.clinic_id ? UserData?.clinic_id : null)).
                then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            reservationDetails: response.data.data ? response.data.data : [],
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error.message)
                })
        }
        catch (error) {
            this.errorMessage(error.message)
        }
    }

    getPatientDetails(PatientId) {
        try {
            let url = Serviceurls.FO_PATIENT_UPDATE + "?patient_id=" + PatientId
            if (this.state.PatientDetails.fromOTModule) {
                url += `&appointment_id=${this.state.PatientDetails.appointment_id}`
            }
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            PatientDetails: response.data.data ? response.data.data : this.state.PatientDetails,
                        }, () => {
                            this.setState({
                                selectedPaymentType: this.state.PatientDetails?.primary_payment_type === 'Corporate credit' ? "Corporate credit" :
                                    this.state.PatientDetails?.primary_payment_type ? this.state.PatientDetails?.primary_payment_type : JSON.parse(localGetItem('allow_patient_credit_bills')) ? "Patient credit" : "",
                                selectedCorporate: this.state.PatientDetails?.company_name,
                                selectedCorporateNumber: this.state.PatientDetails?.id_no,
                                selectedCorporateId: this.state.PatientDetails?.employer_id,
                                selectedInsurance: this.state.PatientDetails?.insurance_company_name,
                                selectedInsuranceNumber: this.state.PatientDetails?.policy_number,
                                selectedInsuranceCCNNumber: this.state.PatientDetails?.ccn_number,
                                selectedTPAName: this.state.PatientDetails?.tpa_name
                            })
                        })
                    }
                    else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        }
        catch (error) {
            this.errorMessage(error.message)
        }
    }
    getAdmissionData() {
        try {
            let IpPatientDetails = getCachevalue('IppatientData')
            let patientData = JSON.parse(IpPatientDetails)
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
            var id = this.props.bacKfromBilling?.ip_admission_id ? this.props.bacKfromBilling?.ip_admission_id : patientData?.id
            let url = `${Serviceurls.IP_ADMISSION_DETAILS}?ip_admission_id=${id}`;
            if (this.props.is_From_Ip_AdmissionDetails && this.state.clinic_id) {
                url = `${url}&clinic_id=${this.state.clinic_id}`
            } else if (this.props.isFromOT) {
                url = `${url}&clinic_id=${UserData?.clinic_id ? UserData?.clinic_id : null}`
            }
            this.lodaerFunction(true)
            RestAPIService.getAll(url).
                then((response) => {
                    if (response.data.status === "success") {
                        this.AdmissionDatas(response.data.data)
                        if (this.props?.bacKfromBilling?.patient_id) {
                            this.getPatientDetails(this.props.bacKfromBilling?.patient_id)
                            this.getLastVisitDateOutstandingAmount(id, this.props?.bacKfromBilling?.patient_id)
                        }
                        if (this.props.isfrom_Patientdetails || this.props.is_From_Ip_AdmissionDetails) {
                            let Data = {
                                photo_url: patientData?.patient_photo_url,
                                first_name: patientData?.patient_name,
                                patient_account_number: patientData?.patient_account_number,
                                mobile_number: patientData?.patient__mobile_number,
                                dob: patientData?.patient__dob,
                                patient_id: patientData?.patient_id,
                                patient_gender: patientData?.patient_gender,

                            }
                            this.setState({
                                PatientDetails: Data
                            })
                        }
                        this.lodaerFunction(false)
                    }
                    else {
                        this.lodaerFunction(false)
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.lodaerFunction(false)
                    this.errorMessage(error.message)
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    GetCorporateList() {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            CorporateList: response.data.data
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error.message)
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }
    getTPAlist = () => {
        try {
            RestAPIService.getAll(Serviceurls.TPA_List)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            TPAList: response?.data?.data ? response?.data?.data : []
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error.message)
                })
        }
        catch (e) {
            this.errorMessage(e?.message)
        }

    }

    getInsuranceList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_INSURANCE_LIST)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            InsuranceList: response.data.data,
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    GetPolicyStatus = () => {
        try {
            let IpPatientDetails = getCachevalue('IppatientData')
            let patientData = JSON.parse(IpPatientDetails)
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
            var id = this.props.bacKfromBilling?.ip_admission_id ? this.props.bacKfromBilling?.ip_admission_id : patientData?.id
            let url = `${Serviceurls.IP_PATIENT_DETAILS_NEW}?admission_id=${id}`;
            if (this.props.is_From_Ip_AdmissionDetails && this.state.clinic_id) {
                url = `${url}&clinic_id=${this.state.clinic_id}`
            } else if (this.props.isFromOT) {
                url = `${url}&clinic_id=${UserData?.clinic_id ? UserData?.clinic_id : null}`
            }
            this.lodaerFunction(true)
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            policyStatus: response.data.data[0].is_final_bill_generated ? true : false,
                        }, () => {
                            this.lodaerFunction(false)
                        })
                    }
                    else {
                        this.lodaerFunction(false)
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.lodaerFunction(false)
                    this.errorMessage(error.message)
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    lodaerFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message,
            DisableBtn: false
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    AdmissionDatas(Datas) {
        try {
            this.setState({
                attrnder_Data: Datas?.attender_config_id,
                patient_Data: Datas?.patient_config_id,
                Doctor: Datas?.doctor_id,
                CoConsultant: Datas?.co_consultant_id,
                Nurse: Datas?.nurse_id,
                Tag: Datas?.patient_tags_id,
                VisitConsult1: Datas?.visiting_doctor_id ? Datas?.visiting_doctor_id : Datas?.visiting_consultant,
                VisitConsult2: Datas?.visiting_doctor_2 ? Datas?.visiting_doctor_2 : Datas?.visiting_consultant_2,
                VisitConsult3: Datas?.visiting_doctor_3 ? Datas?.visiting_doctor_3 : Datas?.visiting_consultant_3,
                VisitConsult4: Datas?.visiting_doctor_4 ? Datas?.visiting_doctor_4 : Datas?.visiting_consultant_4,
                Complaints: Datas?.complaints,
                IsMedicoLegal: Datas?.medico_legal_case,
                MedicoInformer: Datas?.informer_name,
                MedicoLocation: Datas?.incident_location,
                MedicoPoliceStation: Datas?.police_station,
                MedicoComments: Datas?.medico_legal_comments,
                AttenderName: Datas?.attender_name,
                AttenderMobileNo: Datas?.attender_mobile,
                AttenderRelation: Datas?.attender_relationship,
                AttenderLocation: Datas?.attender_location,
                ConsentForAdmissionText: Datas?.consent_for_admission,
                RestraintConsentText: Datas?.restaint_Consent,
                PatientWard: Datas?.patient_config_id?.patinet_ward_name,
                PatientBlock: Datas?.patient_config_id?.patinet_block_name,
                PatientFloor: Datas?.patient_config_id?.patinet_floor,
                PatientRoom: Datas?.patient_config_id?.patinet_room_number,
                PatientBed: Datas?.patient_config_id?.patinet_bed_number,
                PatientRoomType: (Datas?.patient_config_id?.is_hourly && Datas?.patient_config_id?.room_booked_is_hour) ? "hourly" : "day",
                CreditLmt: Datas?.ip_admission_credit_limit,
                PharmaCreditLmt: Datas?.ip_pharmacy_credit_limit,
                MedicoDate: Datas?.incident_date === null ? null : new Date(Datas?.incident_date),
                PatientBedObj: Datas?.patient_config_id,
                bed_ID: Datas?.patient_config_id?.patinet_bed_id,
                selectedCorporate: Datas?.corporate_name ? Datas?.corporate_name : null,
                selectedCorporateNumber: Datas?.id_no ? Datas?.id_no : '',
                selectedInsurance: Datas?.insurance_company_name ? Datas?.insurance_company_name : null,
                selectedInsuranceNumber: Datas?.policy_number ? Datas?.policy_number : '',
                selectedInsuranceCCNNumber: Datas?.ccn_number ? Datas?.ccn_number : '',
                selectedTPAName: Datas?.tpa_name ? Datas?.tpa_name : '',
                selectedPaymentType: Datas?.credit_type === 'Corporate credit' ? "Corporate credit" : Datas?.credit_type ? Datas?.credit_type : JSON.parse(localGetItem('allow_patient_credit_bills')) ? "Patient credit" : "",
                selectedCorporateId: Datas?.employer_id ? Datas?.employer_id : '',
                AddmissionDateTime: new Date(`${Datas?.admission_date}T${Datas?.admission_time}`),
                setMaxAdmissionDateTime: new Date(`${Datas?.created_date}`),
                is_ip_dip_available: Datas?.is_ip_dip_available || false,
            })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    RemoveDuplicates(Array, key) {
        const FilteredArray = Array.reduce((accumulator, current) => {
            if (!accumulator.find((item) => item[key] === current[key])) {
                accumulator.push(current);
            }
            return accumulator;
        }, []);

        return FilteredArray
    }

    FloorCount(value) {
        const FloorCountList = [];
        for (let i = 1; i <= value; i++) { FloorCountList.push(i) }
        return FloorCountList;
    }
    WardSelectionMessage() {
        return (
            <Typography marginLeft={"1vw"} variant='body2' color={Colors.red}>{""}</Typography>
        )
    }
    BedSelectionMessage() {
        return (
            <Typography marginLeft={"1vw"} variant='body2' color={this.state.PatientBederror ? Colors.red : Colors.themeDark}>{this.state.PatientBedtext}</Typography>
        )
    }
    SelectRentTypeRadio(DayRent, HourRent) {
        if (DayRent === true && (HourRent === undefined || HourRent === false)) {
            this.setState({ PatientRoomType: "day" })
        }
        else if ((DayRent === undefined || DayRent === false) && HourRent === true) {
            this.setState({ PatientRoomType: "hourly" })
        }
        else if (DayRent === true && HourRent === true) {
            this.setState({ PatientRoomType: "hourly" })
        }
    }

    GetRoomListData(Date) {
        let IpPatientDetails = getCachevalue('IppatientData')
        let patientData = JSON.parse(IpPatientDetails)
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        let ClinicID = this.state.PatientDetails?.ClinicID ? this.state.PatientDetails?.ClinicID : this.state.clinic_id ? this.state.clinic_id : UserData?.clinic_id;
        try {
            RestAPIService.getAll(Serviceurls.BED_SELECT + "?clinic_id=" + ClinicID)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            PatientWardList: this.RemoveDuplicates(response.data.data, "ward_id"),
                            WardList: response.data.data
                        }, () => {
                            RestAPIService.getAll(Serviceurls.FO_RESERVATION_FILTER_GET + "?patient_id=" + (this.state.PatientDetails.patient_id ? this.state.PatientDetails.patient_id : patientData?.patient_id)).
                                then((Response) => {
                                    if (Response.data.status === "success") {
                                        let PatientReservedData = Response.data?.patient_list?.length > 0 ? Response.data.patient_list[0] : {}
                                        let isReserved = PatientReservedData?.reservation === true
                                        if (isReserved && PatientReservedData?.id) {
                                            let bedObj = this.state.WardList.find((item) => item.bed_id === PatientReservedData.bed_id)
                                            this.setState({
                                                isReservedPatient: true,
                                                reservation_id: PatientReservedData.id,
                                                reservationRoomDetails: PatientReservedData,
                                                PatientWard: PatientReservedData.ward_id,
                                                PatientBlock: PatientReservedData.block_no_id,
                                                PatientFloor: PatientReservedData.floor_number,
                                                PatientRoom: PatientReservedData.room_number,
                                                PatientBed: PatientReservedData.bed_id,
                                                PatientBedObj: bedObj || {},
                                                Doctor: (this.state.DocList?.find((item) => item?.doctor_dr__first_name === CommonValidation.removeSpace(PatientReservedData?.doctor_name)))?.doctor_id ?? this.state.Doctor
                                            }, () => {
                                                if (bedObj) this.SelectRentTypeRadio(bedObj?.is_day, bedObj?.is_hourly)
                                                if (!this.props.is_From_Ip_AdmissionDetails) this.getReservationData()
                                            })
                                        } else {
                                            this.setState({
                                                isReservedPatient: false,
                                                reservation_id: null,
                                                reservationRoomDetails: null
                                            })
                                            if (!this.props.is_From_Ip_AdmissionDetails) this.getReservationData()
                                        }
                                    } else {
                                        this.errorMessage(Response.data.message)
                                    }
                                }).catch((error) => {
                                    this.errorMessage(error.message)
                                })
                        })
                    }
                    else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    GetIntialDatas() {
        try {
            let ClinicID = this.state.PatientDetails.ClinicID ? this.state.PatientDetails.ClinicID : this.state.clinic_id;
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME + "?clinic_id=" + ClinicID).
                then((response) => {
                    if (response.data.status === "success") {
                        let DocData = []
                        DocData = this.RemoveDuplicates(response.data.data, "doctor_name")
                        let docID = DocData.filter((item) => (item.doctor_id == this.state.PatientDetails?.DoctorID))
                        this.setState({
                            DocList: DocData.filter((item) => (item.specialization_active === true)),
                            Doctor: docID?.length > 0 ? docID[0]?.doctor_id : this.state.Doctor
                        })
                    } else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })

            RestAPIService.getAll(Serviceurls.FO_STAFF_LIST + "?clinic_id=" + ClinicID)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            NurseList: response.data.data,
                        })
                    } else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })

            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPPATIENTTAG + "?clinic_id=" + ClinicID)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            TagList: response.data.data,
                        })
                    } else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    getLastVisitDateOutstandingAmount = (AdmissionId = null, Patient_id = null) => {
        try {
            let APIURL = ""
            if (AdmissionId && Patient_id) {
                APIURL = "?patient_id=" + Patient_id + "&module=" + "IP" + "&branch_id=" + localGetItem("BranchId") + "&admission_id=" + AdmissionId
            } else {
                APIURL = "?patient_id=" + this.state.PatientDetails?.patient_id + "&module=" + "IP" + "&branch_id=" + localGetItem("BranchId")
            }
            RestAPIService.getAll(Serviceurls.FO_PATIENT_LAST_VISIT_DATE_AND_BALANCE_AMOUNT + APIURL)
                .then((response) => {
                    if (response.data.status === "success") {
                        let Date = response.data?.last_visited_date ? response.data.last_visited_date : ""
                        let Amount = response.data?.total_outstanding ? response.data.total_outstanding : 0
                        let AdvanceBalance = response.data?.advance_balance ? response.data.advance_balance : 0
                        let Obj = { "last_visited_date": Date, "total_outstanding": Amount, advance_balance: AdvanceBalance }
                        this.setState({
                            LastVisitObject: Obj
                        })
                    } else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }


    renderComponentRight() {
        const { t } = this.props
        let PatientName = this.state.PatientDetails?.first_name ?
            `${this.state.PatientDetails?.first_name ? this.state.PatientDetails?.first_name : ""} ${this.state.PatientDetails?.last_name ? this.state.PatientDetails?.last_name : ""} ` :
            this.state.PatientDetails?.patient_name;

        let PatientAddress = `${(!this.state.PatientDetails?.address_line_1 || this.state.PatientDetails?.address_line_1 === "") ? "-" :
            this.state.PatientDetails?.address_line_1 + ","} ${(!this.state.PatientDetails?.address_line_2 || this.state.PatientDetails?.address_line_2 === "") ? "-" :
                this.state.PatientDetails?.address_line_2 + ","} ${(!this.state.PatientDetails?.city_name || this.state.PatientDetails?.city_name === "") ? "-" :
                    this.state.PatientDetails?.city_name + ","} ${(!this.state.PatientDetails?.state_name || this.state.PatientDetails?.state_name === "") ? "-" :
                        this.state.PatientDetails?.state_name + ","} ${!this.state.PatientDetails?.country || this.state.PatientDetails?.country === "" ? "-" :
                            this.state.PatientDetails?.country + ","} ${!this.state.PatientDetails?.pincode || this.state.PatientDetails?.pincode === "" ? "-" :
                                this.state.PatientDetails?.pincode + "."}`

        const genderIcon = (this.state.PatientDetails?.patient_gender ?
            (this.state.PatientDetails?.patient_gender === "Male" ? <MaleIcon /> : <FemaleIcon />) :
            (this.state.PatientDetails?.gender === "m" ? <MaleIcon /> : <FemaleIcon />));

        return (
            <Paper className='eMed_IPappoint_right'>
                <Typography className='eMed_IPappoint_title'>{t("PatientDetails")}</Typography>
                <Box component={'div'} className='eMed_Ipadmission_Avatar_box'>
                    <img className='eMed_Ipadmission_Avatar_img' src={(this.state.PatientDetails?.photo_url === null || this.state.PatientDetails?.photo_url === "") ? ImagePaths.Male.default : this.state.PatientDetails?.photo_url} alt={'Avatar'} />
                    {PatientName?.length > 40 ? (
                        <Box>
                            <Tooltip placement="top" title={PatientName} arrow>
                                <Box width={"100%"} display={'flex'} flexDirection={"row"} marginY={"1dvw"}>
                                    <Typography>{PatientName?.slice(0, 40) + "..."}</Typography>
                                    {genderIcon}
                                </Box>
                            </Tooltip>
                        </Box>
                    ) : (
                        <Box display={'flex'} flexDirection={"row"} marginY={"1dvw"}>
                            <Typography>{PatientName}</Typography>
                            {genderIcon}</Box>
                    )}
                    <Typography fontSize={"1vw"}>{`${this.state.PatientDetails.patient_account_number}`}</Typography>
                </Box>
                <Divider variant='middle' />
                <Box component={"div"} className='eMed_NxtAppPop_TextDiv' sx={{ marginTop: '1.5vw' }} >
                    <Box component={"div"} className="eMed_details_label">
                        <img src={ImagePaths.LabDateImage} alt="close" className='eMed_nxtAppoint_img_small' />
                        <Typography fontSize={"1vw"} marginLeft={"1vw"}>{this.state.PatientDetails?.dob ? formatDate(this.state.PatientDetails?.dob) : "-"}</Typography>
                    </Box>
                    <Box component={"div"} className="eMed_details_label">
                        {(this.state.PatientDetails?.patient_gender ? (this.state.PatientDetails?.patient_gender === "Male" ? <MaleIcon sx={{ fontSize: "1vw", color: '#616161' }} /> : <FemaleIcon sx={{ fontSize: "1vw", color: '#616161' }} />) : (this.state.PatientDetails?.gender === "m" ? <MaleIcon sx={{ fontSize: "1vw", color: '#616161' }} /> : <FemaleIcon sx={{ fontSize: "1vw", color: '#616161' }} />))}
                        <Typography fontSize={"1vw"} marginLeft={"1vw"}>{this.state.PatientDetails?.patient_gender || (this.state.PatientDetails?.gender === 'm' ? "Male" : (this.state.PatientDetails?.gender === 'f' ? "Female" : "Trans"))}</Typography>
                    </Box>
                    <Box component={"div"} className="eMed_details_label">
                        <img src={ImagePaths.Phone.default} alt="close" className='eMed_nxtAppoint_img_small' />
                        <Typography fontSize={"1vw"} marginLeft={"0.5vw"}>{this.state.PatientDetails?.mobile_number ? this.state.PatientDetails?.mobile_number : "-"}</Typography>
                    </Box>
                </Box>
                {(this.props.isfrom_Patientdetails || this.state.PatientDetails?.fromOTHome || this.props.is_From_Ip_AdmissionDetails) ? null :
                    <Box component={"div"} className='eMed_NxtAppPop_TextDiv' sx={{ marginTop: '1vw' }}>
                        <Box component={"div"} className="eMed_details_label">
                            <img src={ImagePaths.DisabledHome.default} alt="close" className='eMed_nxtAppoint_img_small' />
                            {PatientAddress.length > 120 ?
                                <Tooltip placement='top' title={PatientAddress} arrow>
                                    <Typography fontSize={"0.9vw"} marginX={"1vw"} >{PatientAddress.slice(0, 110) + "..."}</Typography>
                                </Tooltip> :
                                <Typography fontSize={"0.9vw"} marginLeft={"1vw"}>{PatientAddress}</Typography>
                            }
                        </Box>
                    </Box>}

                <Box display={Object.keys(this.state?.LastVisitObject).length > 0 ? "flex" : 'none'} flexDirection={'column'} marginX={"1vw"}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0.5vw' }}>
                        <EventRepeatIcon sx={{ fontSize: "0.9vw", marginRight: '1vw', marginLeft: "-0.2vw", color: '#616161' }} />
                        <Typography fontSize={"0.9vw"}>Last Admission date : </Typography>
                        <Typography fontWeight={600} fontSize={"1dvw"} marginLeft={"0.3vw"}>{this.state.LastVisitObject?.last_visited_date ? this.state.LastVisitObject?.last_visited_date : "-"}</Typography>
                    </Box>
                    <Box sx={{ width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0.5vw' }}>
                        <PaymentsIcon sx={{ fontSize: "0.9vw", marginRight: '1vw', marginLeft: "-0.2vw", color: '#616161' }} />
                        <Typography fontSize={"0.9vw"}>Previous Credit Balance : </Typography>
                        <Typography fontWeight={600} fontSize={"1dvw"} marginLeft={"0.3vw"}>{`${AmountFormat(this.state.LastVisitObject?.total_outstanding || 0)}`}</Typography>
                    </Box>
                    <Box sx={{ width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0.5vw' }}>
                        <PaymentsIcon sx={{ fontSize: "0.9vw", marginRight: '1vw', marginLeft: "-0.2vw", color: '#616161' }} />
                        <Typography fontSize={"0.9vw"}>Previous Advance Balance : </Typography>
                        <Typography fontWeight={600} fontSize={"1dvw"} marginLeft={"0.3vw"}>{`${AmountFormat(this.state.LastVisitObject?.advance_balance || 0)}`}</Typography>
                    </Box>
                </Box>
            </Paper>
        )
    }

    renderTextBox(label, value, Key, maxLength, width, multiline, disable) {
        let states = this.state;
        return (
            <TextField
                disabled={disable}
                inputProps={{ maxLength: maxLength }}
                sx={{ width: width, marginTop: '0.8vw' }}
                size='small'
                label={label}
                value={value}
                onChange={(e) => {
                    if (Key === "AttenderMobileNo") {
                        let number = CommonValidation.numberOnly(e.target.value);
                        if (number || e.target.value === "") {
                            states[Key] = e.target.value
                            this.setState({ states })
                        }
                    }
                    else if (Key === "MedicoComments" || Key === "Complaints" || Key === "MedicoPoliceStation") {
                        let alpha = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                        if (alpha || e.target.value === "") {
                            states[Key] = e.target.value
                            this.setState({ states })
                        }
                    }
                    else {
                        let alpha = CommonValidation.alphabetOnly(e.target.value);
                        if (alpha || e.target.value === "") {
                            states[Key] = e.target.value
                            this.setState({ states })
                        }
                    }

                }}
                multiline={multiline}
                rows={4}
            />
        )
    }

    ComplaintsTextBox() {
        try {
            const { t } = this.props
            let states = this.state
            return (
                <Autocomplete
                    disabled={Object.keys(this.props.bacKfromBilling).length !== 0 || this.props.isPatientDischarged || this.props.is_From_Ip_AdmissionDetails}
                    noOptionsText={states.Complaints === '' ? 'Please Search...' : 'No Data Found...'}
                    options={states.ComplaintsList}
                    getOptionLabel={(options) => options}
                    onChange={(e, value) => {
                        this.setState({
                            Complaints: value,
                        })
                    }}
                    clearIcon={false}
                    size='small'
                    sx={{ width: "28.2vw", marginTop: '0.8vw' }}
                    value={states.Complaints}
                    renderInput={(params) => <TextField sx={{ width: "28.2vw" }}
                        label="Reason / Diagnosis *"
                        value={states.Complaints}
                        onChange={(event) => {
                            this.setState({
                                Complaints: event.target.value
                            })
                        }}
                        {...params}
                    />}
                />)
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    renderDropdown(label, Key, List, LabelKey, ValueKey, disable = false, width) {
        let states = this.state;
        try {
            return (
                <Autocomplete
                    disabled={disable}
                    noOptionsText={'No Data Found...'}
                    options={List}
                    getOptionLabel={(options) => typeof (options) === "string" ? options : options[LabelKey]}
                    freeSolo={(states[Key] === "string") ? true : false}
                    onChange={(e, value) => {
                        if (value === null) {
                            states[Key] = ""
                            this.setState({ states })
                        } else {
                            if (Key === "CoConsultant" && states.Doctor === value[ValueKey]) {
                                this.errorMessage("Please select another doctor")
                            } else if (Key === "Doctor" && states.CoConsultant === value[ValueKey]) {
                                this.errorMessage("Please select another doctor")
                            } else if (Key !== "Nurse" && (states.Doctor === value[ValueKey] || states.CoConsultant === value[ValueKey] || states.VisitConsult1 === value[ValueKey] || states.VisitConsult2 === value[ValueKey] || states.VisitConsult3 === value[ValueKey] || states.VisitConsult4 === value[ValueKey])) {
                                this.errorMessage("Please select another doctor")
                            } else {
                                states[Key] = value[ValueKey]
                                this.setState({ states })
                            }
                        }
                    }}
                    clearIcon={false}
                    size='small'
                    sx={{ width: width, marginTop: '0.8vw' }}
                    value={(typeof (states[Key]) === "string" ? states[Key] : (List?.length > 0 && states[Key]) ? List?.find((item) => (item[ValueKey] === states[Key])) : null)}
                    renderInput={(params) => <TextField sx={{ width: width }} label={label} {...params}
                        onChange={(e) => {
                            if ((Key === "VisitConsult1" || Key === "VisitConsult2" || Key === "VisitConsult3" || Key === "VisitConsult4")) {
                                states[Key] = e.target.value
                                this.setState({ states })
                            }
                        }}
                    />}
                />
            )
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    renderDateTimePicker = (label, value, Key, width, disable) => {
        let states = this.state;
        const isEditableAdmissionDateTime = !this.state.is_user && this.props.isfrom_Patientdetails && JSON.parse(localGetItem('is_admission_datetime_editable')) ? true : false;
        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                    open={Key === "MedicoDate" ? null : this.state.DateOpen}
                    onOpen={() => { this.setState({ DateOpen: Key === "MedicoDate" ? this.state.DateOpen : true }) }}
                    onClose={() => { this.setState({ DateOpen: Key === "MedicoDate" ? this.state.DateOpen : false }) }}
                    label={label}
                    disabled={disable}
                    inputFormat='DD-MM-YYYY & hh:mmA'
                    value={value}
                    minDate={Key === "AddmissionDateTime" && isEditableAdmissionDateTime ? new Date(this.state.setMaxAdmissionDateTime?.getTime() - 3 * 24 * 60 * 60 * 1000) : new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)}
                    maxDateTime={Key === "AddmissionDateTime" && isEditableAdmissionDateTime ? new Date(this.state.setMaxAdmissionDateTime) : new Date()}
                    onChange={(newDate) => {
                        if (newDate) {
                            states[Key] = newDate?.$d
                        }
                        else {
                            states[Key] = new Date()
                        }
                        this.setState({ states }, () => { if (Key === "AddmissionDateTime") { this.GetRoomListData(states[Key]) } })
                    }}
                    renderInput={(params) => <TextField size='small'
                        onClick={() => { this.setState({ DateOpen: Key === "MedicoDate" ? this.state.DateOpen : true }) }}
                        sx={{ width: width, marginTop: '0.8vw', paddingLeft: 0 }}
                        label={label}
                        {...params}
                    />}
                />
            </LocalizationProvider>
        )
    }

    renderAmountTxt = (label, key, width) => {
        var states = this.state
        let { t } = this.props;
        return (
            <TextField
                sx={{ width: width ? width : "16vw", marginTop: "0.9vw" }}
                size='small'
                autoComplete='off'
                label={t(label)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <img src={CurrencySymbol === '$' ? ImagePaths.Dollor.default : ImagePaths.Rupee.default} alt={label} className='eMed_action_img_small' />
                        </InputAdornment>
                    ),
                }}
                value={states[key] ? states[key] : ""}
                disabled={this.props.is_From_Ip_AdmissionDetails}
                onChange={(e) => {
                    let number = CommonValidation.NumberWithDot(e.target.value);
                    if ((number && e.target.value > 0) || e.target.value === "") {
                        states[key] = e.target.value
                        this.setState({
                            states
                        })
                    }
                }}
            />
        )
    }

    navigateToBookRoom = () => {
        const cachePayload = {
            admissionState: this.state,
            patientDetails: this.props.PatientDetails,
        };
        setCachevalue(JSON.stringify(cachePayload), 'IP_ADMISSION_CACHE_KEY');
        this.props.history.push({
            pathname: "/IPHome/RoomBooking",
            state: {
                fromAdmissionDetails: true,
                patientDetails: this.props.PatientDetails,
                doctorId: this.state.Doctor,
                returnPath: "/IPHome/CreateAppointment",
                appointment_id: this.props?.appointment_id,
                recommendation_id: this.props?.recommendation_id,
                ip_request_id: this.props?.ip_request_id,
                consultant_id: this.props?.consultant_id,
            },
        });
    };

    renderBookRoomOnly = () => {
        const { t } = this.props;
        return (
            <Grid container className='eMed_IPappoint_Grid_row' alignItems="center" spacing={2}>
                <Grid item>
                    <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>Room required for admission. Book a reservation first.</Typography>
                </Grid>
                <Grid item>
                    <Button variant="contained" color="primary" size="small" onClick={this.navigateToBookRoom}>
                        Book a room
                    </Button>
                </Grid>
            </Grid>
        );
    };

    PatientBedSelection = () => {
        const { t } = this.props;
        const r = this.state.reservationRoomDetails || {};
        return (
            <Grid container className='eMed_IPappoint_Grid_row' >
                <Grid item xs={2} pr={'1vw'}>
                    <TextField size="small" fullWidth label={t("Ward")} value={r.ward__ward_name ?? ''} disabled />
                </Grid>
                <Grid item xs={2} pr={'1vw'}>
                    <TextField size="small" fullWidth label={t("Block")} value={r.block_no__block_name ?? ''} disabled />
                </Grid>
                <Grid item xs={2} pr={'1vw'}>
                    <TextField size="small" fullWidth label={t("Floor")} value={r.floor_number ?? ''} disabled />
                </Grid>
                <Grid item xs={2} pr={'1vw'}>
                    <TextField size="small" fullWidth label={t("Room")} value={r.room_number ?? ''} disabled />
                </Grid>
                <Grid item xs={2} pr={'1vw'}>
                    <TextField size="small" fullWidth label={t("Bed")} value={r.bed_number ?? ''} disabled />
                </Grid>
            </Grid>
        );
    };
    BedDetailsLabel(Type) {
        try {
            const { t } = this.props
            return (
                <Grid container className='eMed_IPappoint_Grid_row'>
                    <Grid item xs={2.3}>
                        {this.renderTextBox(`${t("Ward")}`, this.state.PatientWard, "VisitConsult1", 50, "90%", false, true)}
                    </Grid>
                    <Grid item xs={2.3}>
                        {this.renderTextBox(`${t("Block")}`, this.state.PatientBlock, "VisitConsult2", 50, "90%", false, true)}
                    </Grid>
                    <Grid item xs={2.3}>
                        {this.renderTextBox(`${t("Floor")}`, this.state.PatientFloor, "VisitConsult3", 50, "90%", false, true)}
                    </Grid>
                    <Grid item xs={2.3}>
                        {this.renderTextBox(`${t("Room")}`, this.state.PatientRoom, "VisitConsult4", 50, "90%", false, true)}
                    </Grid>
                    <Grid item xs={2.3}>
                        {this.renderTextBox(`${t("Bed")}`, this.state.PatientBed, "VisitConsult4", 50, "90%", false, true)}
                    </Grid>
                </Grid>
            )
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }
    renderComponentLeft() {
        const { t } = this.props;
        let isDisable = (Object.keys(this.props.bacKfromBilling).length !== 0 || this.props.isPatientDischarged || this.props.is_From_Ip_AdmissionDetails);
        let isMedicoDisable = (!this.state.IsMedicoLegal || this.props.isPatientDischarged || Object.keys(this.props.bacKfromBilling).length !== 0 || this.props.is_From_Ip_AdmissionDetails);
        let isDisabledByPolicy = (Object.keys(this.props.bacKfromBilling).length !== 0 || this.props.isPatientDischarged || this.state.policyStatus || this.props.is_From_Ip_AdmissionDetails);
        const isDipDisable = (this.props.isPatientDischarged || Object.keys(this.props.bacKfromBilling).length !== 0 || this.props.is_From_Ip_AdmissionDetails || this.props.isfrom_Patientdetails);
        let patientData = getCachevalue('IppatientData') !== 'undefined' ? JSON.parse(getCachevalue('IppatientData')) : {}
        const isEditableAdmissionDateTime = getCachevalue('IppatientData') === null ? false : !this.state.is_user && patientData?.discharge_status !== 'Checked Out' && this.props.isfrom_Patientdetails && JSON.parse(localGetItem('is_admission_datetime_editable')) ? false : true;
        return (
            <Paper className='eMed_IPappoint_left' sx={{ backgroundColor: Colors.ComponentBgColor, paddingX: '0.3vw' }}>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <Typography className='eMed_IPappoint_title'>{t("AdmissionDetails")}</Typography>
                    {this.state.is_dip_available && <RadioGroup
                        value={this.state.is_ip_dip_available}
                        sx={{ display: 'flex', flexDirection: 'row', marginLeft: '1vw' }}
                        onChange={(e) => {
                            this.setState({ is_ip_dip_available: e.target.value === "true" ? true : false })
                        }}
                    >
                        {/* <FormControlLabel value={true} control={<Radio disabled={isDipDisable} size='small' />} label="Delivery IP" /> */}
                        <FormControlLabel value={false} control={<Radio disabled={isDipDisable} size='small' />} label="General IP" />
                    </RadioGroup>}
                </Box>
                <Paper component={'div'} sx={{ backgroundColor: 'white' }}>
                    <Box component={'div'} paddingY={"1vw"}>
                        <Grid container className='eMed_IPappoint_Grid_row'>
                            <Grid item xs={3}>
                                {this.renderDateTimePicker(`${t("AdmissionDateTime*")}`, this.state.AddmissionDateTime, "AddmissionDateTime", "97%", true)}
                            </Grid>
                            <Grid item xs={3}>
                                {this.renderDropdown(`${t("AdmittingConsultant*")}`, "Doctor", this.state.DocList, "doctor_name", "doctor_id", isDisable, "97%")}
                            </Grid>
                            <Grid item xs={3}>
                                {this.renderDropdown(`${t("Co Consultant")}`, "CoConsultant", this.state.DocList, "doctor_name", "doctor_id", isDisable, "97%")}
                            </Grid>
                            <Grid item xs={3}>
                                {this.renderDropdown(`${t("Nurse")}`, "Nurse", this.state.NurseList, "nurse", "staff_id", isDisable, "97%")}
                            </Grid>
                        </Grid>
                        <Grid container className='eMed_IPappoint_Grid_row'>
                            <Grid item xs={3}>
                                {this.renderDropdown(`${t("VisitConsult1")}`, "VisitConsult1", this.state.DocList, "doctor_name", "doctor_id", isDisable, "97%")}
                            </Grid>
                            <Grid item xs={3}>
                                {this.renderDropdown(`${t("VisitConsult2")}`, "VisitConsult2", this.state.DocList, "doctor_name", "doctor_id", isDisable, "97%")}
                            </Grid>
                            <Grid item xs={3}>
                                {this.renderDropdown(`${t("VisitConsult3")}`, "VisitConsult3", this.state.DocList, "doctor_name", "doctor_id", isDisable, "97%")}
                            </Grid>
                            <Grid item xs={3}>
                                {this.renderDropdown(`${t("VisitConsult4")}`, "VisitConsult4", this.state.DocList, "doctor_name", "doctor_id", isDisable, "97%")}
                            </Grid>
                        </Grid>
                        <Grid container className='eMed_IPappoint_Grid_row'>
                            <Grid item xs={6}>
                                {this.ComplaintsTextBox()}
                            </Grid>
                            <Grid item xs={3}>
                                {this.renderDropdown(`${t("Tag")}`, "Tag", this.state.TagList, "patient_tag_name", "id", isDisable, "97%")}
                            </Grid>
                        </Grid>
                    </Box>
                    <Divider variant="middle" />
                    <Box component={'div'} paddingY={"1vw"}>
                        <Grid item xs={12} sx={{ marginTop: "0.5vw" }}>
                            <FormControl sx={{ marginLeft: "1.5vw", display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <label>{t("MedicoLegalCase")} -</label>
                                <RadioGroup
                                    value={this.state.IsMedicoLegal}
                                    sx={{ display: 'flex', flexDirection: 'row', marginLeft: '1vw' }}
                                    onChange={(e) => {
                                        this.setState({ IsMedicoLegal: e.target.value === "true" ? true : false }, () => {
                                            if (!this.state.IsMedicoLegal) {
                                                this.setState({
                                                    MedicoDate: null,
                                                    MedicoInformer: "",
                                                    MedicoLocation: "",
                                                    MedicoPoliceStation: "",
                                                    MedicoComments: "",
                                                })
                                            }
                                        })
                                    }}
                                >
                                    <FormControlLabel value={true} control={<Radio disabled={isDisable} size='small' />} label="Yes" />
                                    <FormControlLabel value={false} control={<Radio disabled={isDisable} size='small' />} label="No" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Box component={'div'} className='eMed_IPappoint_Medico_div'>
                            <Box width={"55%"}>
                                <Grid container className='eMed_IPappoint_Grid_row'>
                                    <Grid item xs={6}>
                                        {this.renderDateTimePicker(`${t("IncidentDateTime*")}`, this.state.MedicoDate, "MedicoDate", "97%", isMedicoDisable)}
                                    </Grid>
                                    <Grid item xs={6}>
                                        {this.renderTextBox(`${t("InformerName*")}`, this.state.MedicoInformer, "MedicoInformer", 50, "97%", false, isMedicoDisable)}
                                    </Grid>
                                </Grid>
                                <Grid container className='eMed_IPappoint_Grid_row' marginTop={"1vw"}>
                                    <Grid item xs={6}>
                                        {this.renderTextBox(`${t("IncidentLocation*")}`, this.state.MedicoLocation, "MedicoLocation", 100, "97%", false, isMedicoDisable)}
                                    </Grid>
                                    <Grid item xs={6}>
                                        {this.renderTextBox(`${t("PoliceStation")}`, this.state.MedicoPoliceStation, "MedicoPoliceStation", 100, "97%", false, isMedicoDisable)}
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box width={"45%"} marginLeft={'0.5vw'}>
                                {this.renderTextBox(`${t("Comments")}`, this.state.MedicoComments, "MedicoComments", 200, "26vw", true, isMedicoDisable)}
                            </Box>
                        </Box>
                    </Box>
                    <Divider variant="middle" />

                    <Box component={'div'} paddingY={"1vw"} >
                        <Typography marginLeft={'1.5vw'}>{t("AttenderDetails")}</Typography>
                        <Grid container className='eMed_IPappoint_Grid_row'>
                            <Grid item xs={3}>
                                {this.renderTextBox(`${t("AttenderName")}`, this.state.AttenderName, "AttenderName", 100, "97%", false, isDisable)}
                            </Grid>
                            <Grid item xs={3}>
                                {this.renderTextBox(`${t("MobileNo")}`, this.state.AttenderMobileNo, "AttenderMobileNo", 10, "97%", false, isDisable)}
                            </Grid>
                            <Grid item xs={3}>
                                {this.renderTextBox(`${t("Relationship")}`, this.state.AttenderRelation, "AttenderRelation", 50, "97%", false, isDisable)}
                            </Grid>
                            <Grid item xs={3}>
                                {this.renderTextBox(`${t("Location")}`, this.state.AttenderLocation, "AttenderLocation", 50, "97%", false, isDisable)}
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
                <Paper sx={{ marginTop: '1vw' }}>
                    <Box component={'div'} borderBottom={'1px solid lightgray'} pl={'1vw'} height={'5vh'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <Box component={'div'} display={'flex'}>
                            <Typography fontSize={'0.9vw'} fontWeight={600}>Payment Type</Typography>
                            <Tooltip placement='top' title='Clear' arrow>
                                <Button className='Common_Btn_Min_Width' sx={{ height: '1.5vw', width: '1.5vw', ml: '0.5vw' }}
                                    disabled={isDisable}
                                    onClick={() => this.setState({
                                        selectedCorporateNumber: '',
                                        selectedInsuranceNumber: '',
                                        selectedInsuranceCCNNumber: '',
                                        selectedTPAName: null,
                                        selectedCorporate: null,
                                        selectedInsurance: null,

                                    })}
                                >
                                    <Box component={'img'} src={ImagePaths.NewClearIcon.default} height={'1.5vw'} width={'1.5vw'} />
                                </Button>
                            </Tooltip>
                        </Box>
                        <Box component={'div'}>
                            <RadioGroup
                                value={this.state.selectedPaymentType}
                                sx={{ display: 'flex', flexDirection: 'row', marginLeft: '1vw' }}
                                onChange={(e) => {
                                    this.setState({ selectedPaymentType: e.target.value })
                                }}
                            >
                                <FormControlLabel value={"Corporate credit"} disabled={isDisabledByPolicy} control={<Radio size='small' />} label="Corporate" />
                                <FormControlLabel value={"Insurance credit"} disabled={isDisabledByPolicy} control={<Radio size='small' />} label="Insurance" />
                                {JSON.parse(localGetItem('allow_patient_credit_bills')) ? <FormControlLabel value={"Patient credit"} disabled={isDisabledByPolicy} control={<Radio size='small' />} label="Patient Credit" /> : null}
                            </RadioGroup>
                        </Box>
                    </Box>
                    <Box component={'div'} mt={'0.5vw'}>
                        <Box component={'div'} pl={'1vw'} height={'5vh'} display={'flex'} alignItems={'center'} borderBottom={'1px solid lightgray'}>
                            <Typography fontSize={'0.9vw'} fontWeight={'600'}>{this.state.selectedPaymentType === 'Corporate credit' ? 'Corporate Details' :
                                this.state.selectedPaymentType === 'Insurance credit' ? 'Insurance Details' : JSON.parse(localGetItem('allow_patient_credit_bills')) ? "Patient credit" : ""}</Typography>
                        </Box>
                        <Box component={'div'} p={'1vw'}>
                            {this.state.selectedPaymentType === 'Corporate credit' ?
                                <Box component={'div'} display={'flex'}>
                                    <Autocomplete
                                        disabled={isDisabledByPolicy}
                                        size='small'
                                        sx={{ width: '15vw', mr: '1vw' }}
                                        options={this.state.CorporateList}
                                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.company_name}
                                        value={this.state.selectedCorporate}
                                        onChange={(e, value) => {
                                            this.setState({ selectedCorporate: value })
                                        }}
                                        renderInput={(params) => <TextField {...params} label='Select Corporate *' />}
                                    />
                                    <TextField
                                        disabled={isDisabledByPolicy}
                                        size='small'
                                        key={"corporateNo"}
                                        sx={{ width: '15vw' }}
                                        label='Employee ID No *'
                                        value={this.state.selectedCorporateNumber}
                                        onChange={(e) => this.setState({ selectedCorporateNumber: e.target.value })}
                                    />
                                </Box>
                                : this.state.selectedPaymentType === 'Insurance credit' ?
                                    <Box component={'div'} display={'flex'}>
                                        <Autocomplete
                                            disabled={isDisabledByPolicy}
                                            size='small'
                                            sx={{ width: '15vw', mr: '0.75vw' }}
                                            options={this.state.InsuranceList}
                                            getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.insurance_name}
                                            value={this.state.selectedInsurance}
                                            onChange={(e, value) => {
                                                this.setState({ selectedInsurance: value, selectedInsuranceNumber: '', selectedInsuranceCCNNumber: '', selectedTPAName: null })
                                            }}
                                            renderInput={(params) => <TextField {...params} label='Select Insurance *' />}
                                        />
                                        <TextField
                                            disabled={isDisabledByPolicy}
                                            key={"insuranceNo"}
                                            size='small'
                                            sx={{ width: '15vw', mr: '0.75vw' }}
                                            label='Insurance No *'
                                            value={this.state.selectedInsuranceNumber}
                                            onChange={(e) => this.setState({ selectedInsuranceNumber: e.target.value })}
                                        />
                                        <TextField
                                            disabled={isDisabledByPolicy}
                                            size='small'
                                            sx={{ width: '15vw', mr: '0.75vw' }}
                                            label='CCN Number'
                                            value={this.state.selectedInsuranceCCNNumber}
                                            onChange={(e) => {
                                                var isAlphaNum = CommonValidation.alphanumValidation(e.target.value)
                                                if ((isAlphaNum || e.target.value == "") && e.target.value.length <= 20) {
                                                    this.setState({ selectedInsuranceCCNNumber: e.target.value })
                                                }
                                            }}
                                        />
                                        {this.state.isTPAConfig ?
                                            <Autocomplete
                                                disableClearable
                                                disabled={isDisabledByPolicy}
                                                sx={{ width: '15vw' }}
                                                //    inputProps={{maxLength :50}}
                                                size='small'
                                                clearIcon={false}
                                                autoComplete='off'
                                                value={this.state.selectedTPAName ? this.state.selectedTPAName : null}
                                                options={this.state.TPAList || []}
                                                getOptionLabel={(option) => (typeof (option) === "string" ? option : option?.tpa_name)}
                                                onChange={(event, newValue) => {
                                                    this.setState({
                                                        selectedTPAName: newValue
                                                    })
                                                }}
                                                renderInput={(params) => <TextField {...params} label={"Select TPA"} />}
                                            />
                                            : <TextField
                                                disabled={isDisabledByPolicy}
                                                size='small'
                                                sx={{ width: '15vw' }}
                                                inputProps={{ maxLength: 50 }}
                                                label='TPA Name'
                                                value={this.state.selectedTPAName}
                                                onChange={(e) => {
                                                    this.setState({ selectedTPAName: e.target.value })
                                                }}
                                            />}
                                    </Box> :
                                    <Typography fontSize={'0.9vw'} color={Colors.SecondaryText}>No Insurance Or Corporate Details</Typography>
                            }
                        </Box>
                    </Box>
                </Paper>
                {/* {this.props.isfrom_Patientdetails ? null : */}
                <Paper sx={{ marginTop: '1vw' }}>
                    <Box className='eMed_IPappoint_title' display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
                        <Box component={'div'} display={'flex'}  >
                            <Box display={'flex'} alignItems={'center'} gap={'0.5vw'}>
                                <Typography sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} fontWeight={600}>{t("PatientWardAllotment")}{this.state.PatientWardList.length === 0 ? this.WardSelectionMessage() : this.BedSelectionMessage()}</Typography>
                                {/* <Tooltip placement='top' title='Clear' arrow>
                                    <Button className='Common_Btn_Min_Width' sx={{ height: '1.5vw', width: '1.5vw' }}
                                        disabled={Object.keys(this.props?.bacKfromBilling).length !== 0 || this.props?.isPatientDischarged || this.props?.isfrom_Patientdetails || this.props.is_From_Ip_AdmissionDetails}
                                        onClick={() => this.setState({
                                            PatientWard: '',
                                            PatientBlock: '',
                                            PatientFloor: '',
                                            PatientRoom: '',
                                            PatientBed: '',
                                            PatientBlockList: [],
                                            PatientRoomList: [],
                                            PatientFloorList: [],
                                            PatientBedList: [],
                                            PatientBedtext: '',
                                            isReservedPatient: false,
                                            reservation_id: null,
                                            reservationRoomDetails: null
                                        })}
                                    >
                                        <Box component={'img'} src={ImagePaths.NewClearIcon.default} height={'1.5vw'} width={'1.5vw'} />
                                    </Button>
                                </Tooltip> */}
                                {this.state.isReservedPatient ? <Typography sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>Reserved Patient</Typography> : false}
                            </Box>
                        </Box>
                        <Box sx={{ marginRight: "1.5vw", display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', gap: '1vw' }}>
                                {(this.state.PatientWard && !this.props.is_From_Ip_AdmissionDetails && !this.props.isfrom_Patientdetails && (this.state.reservationDetails?.length > 0)) ? <Tooltip placement='top' title='Reservation' arrow>
                                    <Button size='small' className='Common_Btn_Min_Width' onClick={() => this.setState({ reservationDataPopup: true })}>
                                        <Box display={'flex'} gap='0.5vw' alignItems={'center'}>
                                            <img src={ImagePaths.IPReservationIcon.default} alt='reservation' />
                                            <Typography fontSize={'0.75vw'}>Reserved List</Typography>
                                            <Avatar sx={{ bgcolor: "red", width: '1.5vw', height: '3vh', fontSize: '0.8rem' }}>{this.state.reservationDetails?.length}</Avatar>
                                        </Box>
                                    </Button>
                                </Tooltip> : null}
                            </Box>
                            <FormControl >
                                {
                                    (Object.keys(this.state.PatientBedObj).length > 0 && this.state.PatientBed !== "") ?
                                        <RadioGroup
                                            value={this.state.PatientRoomType}
                                            sx={{ display: 'flex', flexDirection: 'row', marginLeft: '1vw' }}
                                            onChange={(e) => { this.setState({ PatientRoomType: e.target.value }) }}
                                        >
                                            <FormControlLabel value={"hourly"} control={<Radio disabled={!this.state.PatientBedObj?.is_hourly || this.props.is_From_Ip_AdmissionDetails} size='small' />} label="Hourly" />
                                            <FormControlLabel value={"day"} control={<Radio disabled={!this.state.PatientBedObj?.is_day || this.props.is_From_Ip_AdmissionDetails} size='small' />} label="Day" />
                                        </RadioGroup>
                                        : null
                                }
                            </FormControl>
                            {/* <Tooltip title="Patient Bed Availability List" placement='top' arrow>
                                <IconButton disabled={Object.keys(this.props?.bacKfromBilling).length !== 0 || this.props?.isPatientDischarged || this.props?.isfrom_Patientdetails || this.props.is_From_Ip_AdmissionDetails} onClick={() => { this.setState({ ReservationListPopup: "patient" }) }}><ErrorOutlineIcon color={(Object.keys(this.props?.bacKfromBilling).length !== 0 || this.props?.isPatientDischarged || this.props?.isfrom_Patientdetails) ? "grey" : 'primary'} /></IconButton>
                            </Tooltip> */}
                        </Box>
                    </Box>
                    <Box sx={{ backgroundColor: 'white' }} paddingBottom={"1.5vw"} paddingTop={"0.7vw"}>
                        {(Object.keys(this.props?.bacKfromBilling)?.length !== 0 || this.state.patient_Data.patinet_bed_id)
                            ? this.BedDetailsLabel("patient")
                            : this.state.isReservedPatient
                                ? this.PatientBedSelection()
                                : this.renderBookRoomOnly()}
                    </Box>
                </Paper>
                {/* } */}

                {this.props.isfrom_Patientdetails || this.props.is_From_Ip_AdmissionDetails ? null :
                    <Paper sx={{ marginTop: '1vw', marginBottom: '2vw' }}>
                        <Accordion elevation={2}>
                            <AccordionSummary
                                className='eMed_IPappoint_title'
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography sx={{ fontWeight: 600 }}>{t("ConsentForAdmission")}</Typography>
                            </AccordionSummary>
                            <AccordionDetails className='eMed_TextEditor_Accord'>
                                <Divider />
                                {/* <MUIRichTextEditor
                                    controls={["title", "bold", "italic", "underline", "strikethrough", "highlight", "undo", "redo", "numberList", "bulletList", "quote", "clear", "save"]}
                                    label={` Type ${t("ConsentForAdmission")} Here...`}
                                    onSave={(data) => { this.setState({ ConsentForAdmissionText: data }) }}
                                    inlineToolbar={true}
                                    defaultValue={this.state.ConsentForAdmissionText}
                                /> */}
                            </AccordionDetails>
                        </Accordion>
                    </Paper>}
            </Paper>
        )
    }
    FindByID(List, Id, IdKey, ValueKey) {
        let Data = ""
        Data = List.length > 0 ? List.filter((item) => (item[IdKey] === Id)) : []
        Data = Data.length > 0 ? Data[0][ValueKey] : ""
        return Data
    }
    PostIpAdmission() {
        try {
            var states = this.state
            let IpPatientDetails = getCachevalue('IppatientData')
            let patientData = JSON.parse(IpPatientDetails)
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
            var data = {
                "patient_id": states.PatientDetails?.patient_id,
                "doctor_id": states.Doctor,
                "co_consultant_id": states.CoConsultant ? states.CoConsultant : null,
                "admission_date": DateTime.fromJSDate(this.state.AddmissionDateTime).toFormat("yyyy-MM-d"),
                "admission_time": DateTime.fromJSDate(this.state.AddmissionDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS),
                "nurse_id": states.Nurse ? states.Nurse : null,
                "complaints": CommonValidation.removeSpace(states.Complaints),
                "floor": states.PatientFloor?.toString(),
                "room": states.PatientRoom,
                "bed_id": this.props.isfrom_Patientdetails ? states.bed_ID : states.PatientBed,
                "patient_account_number": states.PatientDetails?.patient_account_number,
                "tentative_discharge_date": null,
                "visiting_consultant": typeof (states.VisitConsult1) !== 'number' ? CommonValidation.removeSpace(states.VisitConsult1) : states?.DocList.find((item) => item?.doctor_id === states.VisitConsult1)?.doctor_name,
                "visiting_consultant_2": typeof (states.VisitConsult2) !== 'number' ? CommonValidation.removeSpace(states.VisitConsult2) : states?.DocList.find((item) => item?.doctor_id === states.VisitConsult2)?.doctor_name,
                "visiting_consultant_3": typeof (states.VisitConsult3) !== 'number' ? CommonValidation.removeSpace(states.VisitConsult3) : states?.DocList.find((item) => item?.doctor_id === states.VisitConsult3)?.doctor_name,
                "visiting_consultant_4": typeof (states.VisitConsult4) !== 'number' ? CommonValidation.removeSpace(states.VisitConsult4) : states?.DocList.find((item) => item?.doctor_id === states.VisitConsult4)?.doctor_name,
                "visiting_doctor_id": typeof (states.VisitConsult1) !== 'number' ? null : states.VisitConsult1,
                "visiting_doctor_2_id": typeof (states.VisitConsult2) !== 'number' ? null : states.VisitConsult2,
                "visiting_doctor_3_id": typeof (states.VisitConsult3) !== 'number' ? null : states.VisitConsult3,
                "visiting_doctor_4_id": typeof (states.VisitConsult4) !== 'number' ? null : states.VisitConsult4,
                "medico_legal_case": states.IsMedicoLegal,
                "incident_date": states.MedicoDate === null ? null : DateTime.fromJSDate(states.MedicoDate).toFormat("yyyy-MM-d"),
                "incident_time": states.MedicoDate === null ? null : DateTime.fromJSDate(states.MedicoDate).toLocaleString(DateTime.TIME_24_WITH_SECONDS),
                "incident_location": CommonValidation.removeSpace(states.MedicoLocation),
                "informer_name": CommonValidation.removeSpace(states.MedicoInformer),
                "police_station": CommonValidation.removeSpace(states.MedicoPoliceStation),
                "medico_legal_comments": CommonValidation.removeSpace(states.MedicoComments),
                "ward": this.state.isReservedPatient && this.state.reservationRoomDetails
                    ? (this.state.reservationRoomDetails.ward__ward_name ?? '')
                    : this.FindByID(states.PatientWardList, states.PatientWard, "ward_id", "ward_name"),
                "block": this.state.isReservedPatient && this.state.reservationRoomDetails
                    ? (this.state.reservationRoomDetails.block_no__block_name ?? '')
                    : this.FindByID(states.PatientBlockList, states.PatientBlock, "block_id", "block_name"),
                "attender_name": CommonValidation.removeSpace(states.AttenderName),
                "attender_mobile": CommonValidation.removeSpace(states.AttenderMobileNo),
                "attender_relationship": CommonValidation.removeSpace(states.AttenderRelation),
                "attender_location": CommonValidation.removeSpace(states.AttenderLocation),
                "patient_tags_id": states.Tag,
                "restaint_Consent": states.RestraintConsentText,
                "consent_for_admission": states.ConsentForAdmissionText,
                'is_hourly': states.PatientRoomType === "hourly",
                'is_day': states.PatientRoomType === "day",
                "ip_admission_credit_limit": states.CreditLmt ? +CommonValidation.removeSpace(states.CreditLmt) : 0,
                "ip_pharmacy_credit_limit": states.PharmaCreditLmt ? +CommonValidation.removeSpace(states.PharmaCreditLmt) : 0,
                "clinic_id": UserData?.clinic_id,
                "ot_id": this.props.PatientDetails?.ot_id ? this.props.PatientDetails?.ot_id : this.props.PatientDetails?.OTid ? this.props.PatientDetails?.OTid : null,
                "credit_type": this.state.selectedPaymentType === 'Corporate credit' ? 'Corporate credit' : this.state.selectedPaymentType === 'Insurance credit' ? "Insurance credit" : JSON.parse(localGetItem('allow_patient_credit_bills')) ? "Patient credit" : "",
                "employer_id": this.state.selectedPaymentType === 'Corporate credit' ? (this.state.selectedCorporate?.id ? this.state.selectedCorporate?.id : this.state.selectedCorporateId) : null,
                "id_no": this.state.selectedPaymentType === 'Corporate credit' ? this.state.selectedCorporateNumber : "",
                "insurance_company_name": this.state.selectedPaymentType === 'Insurance credit' ? (this.state.selectedInsurance?.insurance_name ? this.state.selectedInsurance?.insurance_name : this.state.selectedInsurance) : '',
                "policy_no": this.state.selectedPaymentType === 'Insurance credit' ? this.state.selectedInsuranceNumber : '',
                "ccn_number": this.state.selectedPaymentType === 'Insurance credit' ? this.state.selectedInsuranceCCNNumber : '',
                "tpa_name": this.state.selectedPaymentType === 'Insurance credit' ? CommonValidation.removeSpace(typeof this.state.selectedTPAName === 'object' ? this.state.selectedTPAName?.tpa_name || this.state.selectedTPAName?.name || '' : this.state.selectedTPAName || '') : '',
                "reservation_id": this.state.reservation_id ? this.state.reservation_id : null,
                "is_ip_dip_available": this.state.is_ip_dip_available || false,
                "appointment_id": this.props?.appointment_id || null,
                "ip_request_id": this.props?.ip_request_id || null,
                "recommendation_id": this.props?.recommendation_id || null
            }

            if (this.props.isfrom_Patientdetails) {
                data["ip_admission_id"] = patientData?.id
                let patientTag = this.state.TagList?.find(item => item?.id === states.Tag)
                patientData.patient_tags_id = patientTag?.id
                patientData.attender_name = this.state.AttenderName ? this.state.AttenderName : ""
                patientData.attender_mobile = this.state.AttenderMobileNo ? this.state.AttenderMobileNo : ""
                patientData.patient_tags__patient_tag_name = patientTag?.patient_tag_name
                patientData.company_name = this.state.selectedCorporate?.company_name || this.state.selectedCorporate || ""
                patientData.employee_id = this.state.selectedCorporateNumber || ""
                patientData.insurance_name = this.state.selectedInsurance?.insurance_name || this.state.selectedInsurance || ""
                patientData.policy_number = this.state.selectedInsuranceNumber || ""

                if (data?.credit_type !== patientData?.primary_payment_type) {
                    patientData.primary_payment_type = data.credit_type
                }
            }
            if (this.state.selectedPaymentType === 'Corporate credit' && ((this.state.selectedCorporate === null || this.state.selectedCorporate === '') || (this.state.selectedCorporateNumber === '' || this.state.selectedCorporateNumber === null))) {
                this.errorMessage("Select Corporate Details")
            } else if (this.state.selectedPaymentType === 'Insurance credit' && ((this.state.selectedInsurance === null || this.state.selectedInsurance === '') || (this.state.selectedInsuranceNumber === '' || this.state.selectedInsuranceNumber === null))) {
                this.errorMessage("Select Insurance Details")
            } else {
                this.lodaerFunction(true)
                RestAPIService.create(data, Serviceurls.IP_ADMISSION_DETAILS)
                    .then((response) => {
                        if (response?.data?.status === "success") {
                            this.lodaerFunction(false)
                            this.setState({ DisableBtn: false })
                            if (this.props.appointment_id) {
                                try {
                                    let data = {
                                        appointment_id: this.props?.appointment_id || null,
                                        ip_request_status: "accepted",
                                        ip_admission_id: response.data.data.ip_admission_id,
                                        ip_request_id: this.props?.ip_request_id || null
                                    }
                                    RestAPIService.updateWithOutId(data, Serviceurls.OP_TO_IP_MOVE)
                                        .then((res) => {
                                            if (res?.data?.status === 'Success') {
                                                this.successMessage(res.data.message)
                                            }
                                        }).catch((error) => {
                                            this.errorMessage(error?.res?.data?.message || error.message)
                                        })
                                } catch (error) {
                                    this.errorMessage(error.message)
                                }
                            }
                            setCachevalue(JSON.stringify(patientData), 'IppatientData')
                            if (this.props.isfrom_Patientdetails) {
                                const isEditableAdmissionDateTime = JSON.parse(localGetItem('is_admission_datetime_editable'));
                                if (isEditableAdmissionDateTime) {
                                    let patientData_ip = JSON.parse(getCachevalue('IppatientData'))
                                    let startDate = new Date(this.state.AddmissionDateTime)
                                    patientData_ip['admission_date'] = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd hh:mm a')
                                    patientData_ip['admission_time'] = DateTime.fromJSDate(startDate).toFormat('hh:mm a')
                                    setCachevalue(JSON.stringify(patientData_ip), 'IppatientData')
                                }
                                this.props.history.push("/IPHome/PatientDetails/PatientDetails")
                            } else {
                                this.props.IPAdmisssionSuccess(response?.data?.message, response?.data?.data)
                            }
                            this.setState({ selectedCorporateId: null })
                        } else {
                            this.lodaerFunction(false)
                            this.errorMessage(response.data.message)
                        }
                    }).catch(error => {
                        this.lodaerFunction(false)
                        this.errorMessage(error?.response?.data?.message || error.message)
                    })
            }
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    Validation() {
        let states = this.state;
        if (
            !(DateTime.fromJSDate(this.state.AddmissionDateTime).toFormat("yyyy-MM-d") === "Invalid DateTime") &&
            !(DateTime.fromJSDate(this.state.AddmissionDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS) == "Invalid DateTime") &&
            states.Doctor !== "" &&
            CommonValidation.removeSpace(states.Complaints) !== "" &&
            states.PatientBed !== ""
        ) {
            if (states.IsMedicoLegal) {
                if (
                    (!(DateTime.fromJSDate(this.state.MedicoDate).toFormat("yyyy-MM-d") === "Invalid DateTime")) &&
                    !(DateTime.fromJSDate(this.state.MedicoDate).toLocaleString(DateTime.TIME_24_WITH_SECONDS) == "Invalid DateTime") &&
                    CommonValidation.removeSpace(states.MedicoInformer) !== "" &&
                    CommonValidation.removeSpace(states.MedicoLocation) !== ""
                ) {
                    this.PostIpAdmission()
                }
                else {
                    this.setState({ DisableBtn: false }, () => {
                        if ((DateTime.fromJSDate(this.state.MedicoDate).toFormat("yyyy-MM-d") === "Invalid DateTime") || (DateTime.fromJSDate(this.state.MedicoDate).toLocaleString(DateTime.TIME_24_WITH_SECONDS) == "Invalid DateTime")) {
                            this.errorMessage("Invalid Incident Date & Time")
                        }
                        else if (CommonValidation.removeSpace(states.MedicoInformer) === "") {
                            this.errorMessage("Enter the Informer Name")
                        }
                        else if (CommonValidation.removeSpace(states.MedicoLocation) === "") {
                            this.errorMessage("Enter the Location of the Incident")
                        }
                    })
                }
            }
            else {
                this.PostIpAdmission()
            }
        }
        else {
            this.setState({ DisableBtn: false }, () => {
                if ((DateTime.fromJSDate(this.state.AddmissionDateTime).toFormat("yyyy-MM-d") === "Invalid DateTime") || (DateTime.fromJSDate(this.state.AddmissionDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS) == "Invalid DateTime")) {
                    this.errorMessage("Invalid Admission Date & Time")
                }
                else if (states.Doctor === "") {
                    this.errorMessage("Select the Admitting Consultant")
                }
                else if (CommonValidation.removeSpace(states.Complaints) === "") {
                    this.errorMessage("Enter the Reason / Diagnosis")
                }
                else if (states.PatientBed === "") {
                    this.errorMessage("Select the Bed for Patient")
                }
            })
        }
    }
    clearData() {
        this.setState({
            IsMedicoLegal: false,
            PatientBlockList: [],
            PatientFloorList: [],
            PatientBedList: [],
            PatientRoomList: [],
            PatientWard: "",
            PatientBlock: "",
            PatientFloor: "",
            PatientRoom: "",
            PatientBed: "",
            PatientFloorId: "",
            PatientBederror: false,
            PatientBedtext: "",

            AddmissionDateTime: new Date(),
            Doctor: "",
            CoConsultant: "",
            Nurse: "",
            Tag: "",
            VisitConsult1: "",
            VisitConsult2: "",
            VisitConsult3: "",
            VisitConsult4: "",
            Complaints: "",
            MedicoDate: null,
            MedicoInformer: "",
            MedicoLocation: "",
            MedicoPoliceStation: "",
            MedicoComments: "",
            AttenderName: "",
            AttenderMobileNo: "",
            AttenderRelation: "",
            AttenderLocation: "",
            PatientBedObj: {},
            PatientRoomType: "hourly",
            CreditLmt: 0,
            PharmaCreditLmt: 0,

            selectedCorporate: null,
            selectedInsurance: null,
            selectedCorporateNumber: '',
            selectedInsuranceNumber: '',
            selectedInsuranceCCNNumber: '',
            selectedTPAName: null,
            selectedPaymentType: JSON.parse(localGetItem('allow_patient_credit_bills')) ? 'Patient credit' : '',
            is_ip_dip_available: false,
        })
    }
    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            BackBtnClicked: false
        })
    }
    AllowBack() { { this.props.BackToRegistration(this.state.PatientDetails) } }
    reserveClose() { { this.setState({ ReservationListPopup: null }) } }
    RommDetail(item) {
        var states = this.state
        if (this.state.ReservationListPopup === "patient") {
            states.PatientWardList.push({
                ward_id: item.ward_id,
                ward_name: item.ward__ward_name
            })
            states.PatientBlockList.push({
                block_id: item.block_no_id,
                block_name: item.block
            })
            states.PatientFloorList.push({
                floor: item.floor
            })
            states.PatientRoomList.push({
                room_number: item.room_number
            })
            states.PatientBedList.push({
                bed_id: item.bed_id,
                bed_number: item.bed_number
            })
            this.setState({
                PatientWard: item.ward_id,
                PatientBlock: item.block_no_id,
                PatientFloor: item.floor,
                PatientRoom: item.room_number,
                PatientBed: item.bed_id,
                states,
                PatientBedObj: item
            }, () => {
                this.SelectRentTypeRadio(this.state.PatientBedObj?.is_day, this.state.PatientBedObj?.is_hourly)
            })
        }
    }

    renderReservationPopup = () => {
        const { t } = this.props
        const columns = [
            { field: 'patient_name', headerName: t('Patient Details'), headerClassName: 'eMed_Apt_TblHead', flex: 0.20, renderCell: ({ row }) => (<CommonPatientDetails data={row} showAdmissionDateOnly={true} showAproxDate={true} />), density: 'compact' },
            {
                field: 'complaints', headerName: t('Reservation Details'), headerClassName: 'eMed_Apt_TblHead', flex: 0.14, density: 'compact',
                renderCell: ({ row }) => (
                    <div>
                        <div className='eMed_OP_PatientType'> <Typography id='eMed_OP_AptTbl_AptText' sx={{ fontWeight: '600' }}>{row.approx_check_in_date ? row.approx_check_in_date : '-'}</Typography></div>
                        <div>{row.complaints && row.complaints?.length > 18 ?
                            <Tooltip title={row.complaints ? row.complaints : null} placement={'top'} arrow>
                                <Typography id='eMed_OP_AptTbl_AptText1'>{row.complaints ? row.complaints?.slice(0, 15) + '...' : '-'}</Typography>
                            </Tooltip> : <Typography id='eMed_OP_AptTbl_AptText1'>{row.complaints ? row.complaints : '-'}</Typography>} </div>
                    </div>)
            },
            {
                field: 'ward_block_floor', headerName: t('Ward/Block/Floor'), headerClassName: 'eMed_Apt_TblHead', flex: 0.12, density: 'compact',
                renderCell: ({ row }) => {
                    let ward_block_floor = `${row.ward_name ? row.ward_name : "-"}/${row.block_name ? row.block_name : "-"}/${row.floor_number ? row.floor_number : (row.floor_number == 0 ? 0 : "-")}`
                    return (<div>{ward_block_floor.length > 15 ? <Tooltip placement="top" title={ward_block_floor} arrow><div>{ward_block_floor?.slice(0, 15) + "..."}</div></Tooltip> : ward_block_floor ? ward_block_floor : "-"}</div>)
                }
            },
            {
                field: 'advance_amount', headerName: `${t("Advance")} (${CurrencySymbol})`, headerClassName: 'eMed_Apt_TblHead', flex: 0.11, density: 'compact', type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.advance_amount ? AmountFormat(params?.row?.advance_amount)?.replace(`${CurrencySymbol}`, "") : "0"}</Box>)
            },
        ];
        return (
            <Box component={'div'}>
                <Modal
                    open={this.state.reservationDataPopup}
                >
                    <Box component={'div'} className="eMed_Asset_Sts_Cge_style" sx={{ height: '75vh', width: '60vw', p: '1vw' }}>
                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'0.5vw'} borderBottom={'1px solid lightgray'} mb={"0.5vw"}>
                            <Typography fontSize={'0.9vw'} fontWeight={600}>Reservation Details</Typography>
                            <Button
                                className="Common_Btn_Min_Width"
                                onClick={() => this.setState({ reservationDataPopup: false })}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                            </Button>
                        </Box>
                        <Box className='eMed_IPAptTbl_Con' sx={{ width: '100%', height: '62vh' }}>
                            <DataGrid
                                rows={this.state.reservationDetails}
                                columns={columns}
                                getRowId={(row) => row.id}
                                pageSize={this.state.pageSize}
                                page={this.state.page}
                                rowsPerPageOptions={[10, 20, 30]}
                                components={{
                                    NoRowsOverlay: () => (
                                        <Stack className='eMed_conf_nodata'>
                                            {t("NoRecordsFound")}
                                        </Stack>
                                    )
                                }}
                                localeText={{
                                    toolbarColumns: "",
                                    toolbarDensity: "",
                                    toolbarExport: "",
                                    toolbarFilters: "",
                                    toolbarExportPrint: ""
                                }}
                                density={'compact'}
                                rowHeight={100}
                                pagination
                                onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                                onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }) }}
                                disableSelectionOnClick
                                loading={this.state.isLoader}
                            />
                        </Box>
                    </Box>
                </Modal>
            </Box>
        )
    }

    render() {
        try {
            return (
                <Box component={"div"} className='eMed_Ipappoint_container'>
                    <Grid container spacing={1} className='eMed_IPappoint_content' >
                        <Grid item xs={8} sx={{ padding: 0 }}>
                            {this.renderComponentLeft()}
                        </Grid>
                        <Grid item xs={4}>
                            {this.renderComponentRight()}
                        </Grid>
                        {this.props.is_From_Ip_AdmissionDetails ? null :
                            <Grid item xs={12}>
                                <Box className='eMed_Ipappoint_btn_div'>
                                    <Button id="eMed_invd_Button" size='small' variant='outlined' onClick={() => { (this.state.PatientDetails?.fromOTModule || this.props.isFromOT) ? this.props.history.push("/OTHome") : this.state.PatientDetails?.fromOTHome ? this.props.history.push("/IPHome/OThome") : this.props.isfrom_Patientdetails ? this.props.history.push("/IPHome/PatientDetails/PatientDetails") : Object.keys(this.props.bacKfromBilling)?.length === 0 ? this.setState({ BackBtnClicked: true }) : this.props.BackToRegistration(this.state.PatientDetails) }}>Back</Button>
                                    <Button disabled={Object.keys(this.props.bacKfromBilling).length !== 0 || this.props.isPatientDischarged} id="eMed_invd_Button" size='small' variant='outlined' onClick={() => { this.clearData() }}>Clear</Button>
                                    <Button disabled={this.state.isLoader ? true : Object.keys(this.props.bacKfromBilling).length !== 0 || this.props.isPatientDischarged} id="eMed_invd_Button" emed_tid="Create_Admission_Btn" size='small' variant='contained' onClick={() => { this.Validation() }}>{this.props.isfrom_Patientdetails ? 'Update Admission' : 'Create Admission'}</Button>
                                    {
                                        Object.keys(this.props.bacKfromBilling).length !== 0 ?
                                            <Button id="eMed_invd_Button" size='small' variant='outlined' onClick={() => { this.props.BackToBilling() }}>Next</Button> : null
                                    }
                                </Box>
                            </Grid>}
                    </Grid>
                    {this.renderReservationPopup()}
                    {this.state.isErrorMsg ?
                        <ToastMsg
                            severity={'error'}
                            msg={this.state.isErrorMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                    {this.state.successMsg ?
                        <ToastMsg
                            severity={'success'}
                            msg={this.state.successMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                    <Loader loaderOpen={this.state.isLoader} />
                    {this.state.BackBtnClicked ? <DeletePopup
                        DeletTitle={` Are you sure to discard the entered Values ?`}
                        deleteAlertPopupClose={this.msgClose.bind(this)}
                        removeData={this.AllowBack.bind(this)}
                        DeleteNotify={(" Cannot Retrieve the Values")}
                        ButtonText={'Yes'}
                    /> : null}
                </Box>
            )
        }
        catch (e) {
            this.errorMessage(e.message)
            return null
        }
    }
}
export default withTranslation()(IPAddmissionDetails)